// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","scrollBody":"scrollBody-2j8Qf","paper":"paper-2VanC"};